import { render, staticRenderFns } from "./ViewAccessrule.vue?vue&type=template&id=1ad9785b&scoped=true&"
import script from "./ViewAccessrule.vue?vue&type=script&lang=js&"
export * from "./ViewAccessrule.vue?vue&type=script&lang=js&"
import style0 from "./ViewAccessrule.vue?vue&type=style&index=0&id=1ad9785b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad9785b",
  null
  
)

export default component.exports